import Link from "next/link";
import { Table, Skeleton } from "antd";
import * as ROUTES from "constants/routes";
import useClientData from "hooks/api/client/useClientData";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (id) => (
      <Link href={ROUTES.CLIENTS_DETAIL} as={`/clients/${id}`}>
        <a>{id}</a>
      </Link>
    ),
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Short name",
    dataIndex: "short_name",
    key: "short_name",
  },
];

function AllClients() {
  const { status, data, error } = useClientData();
  if (status === "loading") {
    return <Skeleton />;
  }

  if (error) {
    return "Error";
  }

  return (
    <Table columns={columns} dataSource={data} rowKey={(client) => client.id} />
  );
}

export default AllClients;
